import { actionTypes } from "./wellnessModalStatus.actions";

export interface IWellnessModalStatus {
  showWellnessUpsell: boolean;
}

const initialState: IWellnessModalStatus = {
  showWellnessUpsell: false,
};

export const wellnessModalStatusReducer = (
  state: IWellnessModalStatus = initialState,
  action: { type: string, payload: boolean },
) => {
  switch (action.type) {
  case actionTypes.SET_SHOW_WELLNESS_UPSELL:
    return {
      ...state,
      showWellnessUpsell: action.payload,
    };
  default:
    return state;
  }
};
